import { TextField, Tooltip } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import moment from "moment";

import { APICall } from "../../../Helpers/API/APICalls";
import {
  getFunctionalOwnersforEngagementReport,
  getDashBoardDataForEngagementReport,
  getStagesForEngagementReport,
  getCustomerDataForEngagementReport,
  ExporttoExcelEngagementReport,
} from "../../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import axios from "axios";
import fileDownload from "js-file-download";

const EngagementReport = () => {
  let formErrorObj = {};
  const [formErrors, setFormErrors] = useState({});
  const [gridData, setGridData] = useState<any>([]);
  const [loader, setLoader] = useState(true);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [customersSelected, setCustomersSelected] = useState([]);

  const [functionalOwnerOptions, setFunctionalOwnerOptions] = useState([]);
  const [functionalOwnerSelected, setFunctionalOwnerSelected] = useState([]);

  const [stageoptions, setStageOptions] = useState([]);
  const [stageSelectedData, setStageSelectedData] = useState([]);

  const [postObject, setPostObject] = useState({});

  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageSize, setpageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [reset, setReset] = useState(false);
  const [page, setPage] = useState(0);
  const { RoleId, EmployeeId } = getContext();
  const RoleIdArray = RoleId.split(",");

  useEffect(() => {
    onLoadApi();
  }, []);

  useEffect(() => {
    (async () => {
      if (loader == false) {
        let customers = await ConvertArrayToString(customersSelected);
        let functionalOwner = await ConvertArrayToString(
          functionalOwnerSelected
        );
        let stag = await ConvertArrayToString(stageSelectedData);
        let RoleIdToSend;
        let EmpId;
        if (RoleId.includes("3")) {
          RoleIdToSend =3;
         EmpId=EmployeeId;
        }else if (RoleIdArray.includes("8")) {
          RoleIdToSend =8;
         EmpId=EmployeeId;
          }
        else if (RoleIdArray.includes("7")) {
          RoleIdToSend =7;
         EmpId=EmployeeId;
          }
        else if (RoleIdArray.includes("2")) {
          RoleIdToSend =2;
         EmpId=EmployeeId;
          };
        
        let obj = {
          CustId: customers,
          FunctionalOwner: functionalOwner,
          StageId: stag,
          RoleId:RoleIdToSend,
          Id:EmpId,

          SortColumn: sortColumn,
          SortOrder: sortOrder,
          SearchText: searchText,
          PageSize: pageSize,
          Start: start,
          Count:count,
        };
        await GetGridData(obj);
       
      }
    })();
  }, [start, sortColumn, sortOrder, searchText, reset, pageSize,page]);

  const onLoadApi = async () => {
    await GetCustomersData();
    await GetStageData();
    await GetFunctionalOwnerData();
    setLoader(false);
  };

  const GetGridData = async (obj) => {
    showLoader();
    const { data } = await APICall(
      getDashBoardDataForEngagementReport,
      "POST",
      obj
    );
    hideLoader();
    let arr = [];
    if (data.length > 0) {
      arr = [...data];
      setCount(arr[0].totalCount);
      setGridData(data);
    }
   else {
      setStart(0);
      setCount(0);
      setPage(0);
      setGridData([]);
    }
    
  };

  const SelectOnChange = (event, apiField) => {
    if (apiField == "stages") {
      setStageSelectedData(event);
    }

    if (apiField == "customer") {
      setCustomersSelected(event);
    }

    if (apiField == "functionalOwner") {
      setFunctionalOwnerSelected(event);
    }
  };

  const GetFunctionalOwnerData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        searchValue: EmployeeId,
      };
    } 
    // added by mahesh 
    else if (RoleIdArray.includes("8")) {
      postObject = {
        RoleId: 8,
        Id: EmployeeId,
      };
    }

    else if (RoleIdArray.includes("7")) {
      postObject = {
        RoleId: 7,
        Id: EmployeeId,
      };
    } 
    else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    } 
    //added by mahesh 
    // if (RoleIdArray.includes("8")) {
    //   postObject = {
    //     RoleId: 8,
    //     Id: EmployeeId,
    //   };
    // } 
    // end 

    const { data } = await APICall(
      getFunctionalOwnersforEngagementReport,
      "POST",
      postObject
    );
   // console.log("FunctionOwnerData", data);
    if (data != undefined || data != null) {
      let functionalOwnerArray = [];

      await data.map((x: any) => {
        let tempObj = {
          value: x.value,
          label: x.label,
        };
        functionalOwnerArray.push(tempObj);
      });
      functionalOwnerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setFunctionalOwnerOptions(functionalOwnerArray);
    }
  };

  const GetCustomersData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        Id: EmployeeId,
      };
    } 
    else if (RoleIdArray.includes("7")) {
      postObject = {
        RoleId: 7,
        Id: EmployeeId,
      };
    }
    
    else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    }
    //added by mahesh
    if (RoleIdArray.includes("8")) {
      postObject = {
        RoleId: 8,
        Id: EmployeeId,
      };
    }
    //end 

    const { data } = await APICall(
      getCustomerDataForEngagementReport,
      "POST",
      postObject
    );

    //console.log("CUstomer Data", data);
    if (data != undefined || data != null) {
      let customerArray = [];

      await data.map((x: any) => {
        let tempObj = {
          value: x.customerId,
          label: x.customer,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setCustomerOptions(customerArray);
    }
  };

  const GetStageData = async () => {
    let postObject = {};

    if (RoleId.includes("3")) {
      postObject = {
        RoleId: 3,
        searchValue: EmployeeId,
      };
    } 
    else if (RoleIdArray.includes("7")) {
      postObject = {
        RoleId: 7,
        Id: EmployeeId,
      };
    }
    
    else if (RoleIdArray.includes("2")) {
      postObject = {
        RoleId: 2,
        Id: EmployeeId,
      };
    }

    const { data } = await APICall(
      getStagesForEngagementReport,
      "POST",
      postObject
    );

    if (data != undefined || data != null) {
      let stageArray = [];

      await data.map((x: any) => {
        let tempObj = {
          value: x.value,
          label: x.label,
        };
        stageArray.push(tempObj);
      });
      stageArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      setStageOptions(stageArray);
    }
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const gridColumns = [
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },
    {
      name: "customer",
      label: "Customer",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },
    
    {
      name: "stage",
      label: "Stage",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },
    {
      name: "functionalOwner",
      label: "Functional Owner",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },
    {
      name: "poStatus",
      label: "PoStatus",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },

    {
      name: "balanceValue",
      label: "Balance Value",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "right" }),
      },
    },

    {
      name: "budgetMandays",
      label: "Budget Mandays",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "right" }),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "left" }),
      },
    },

    {
      name: "totalSpentmanDays",
      label: "Total Spent ManDays",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "right" }),
      },
    },
    {
      name: "balanceMandays",
      label: "Balance Mandays",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ align: "right" }),
      },
    },
  ];

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  const onInput = debounce((searchText) => {
    if (searchText !== null) {
      setSearchText(searchText);
    } else {
      setSearchText("");
    }
  }, 1000);

  const object = {
    selectableRows: "none",
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      onInput(searchText);
    },
    onColumnSortChange: async (sortColumn, sortOrder) => {
      if (sortOrder === "asc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
      if (sortOrder === "desc") {
        await setSortColumn(sortColumn);
        await setsortOrder(sortOrder);
      }
    },
    onChangePage: async (page) => {
      setPage(page);

      setStart(page * pageSize);
    },
  };

  const submitFunc = async (api) => {
    let customers = await ConvertArrayToString(customersSelected);
    let functionalOwner = await ConvertArrayToString(functionalOwnerSelected);
    let stag = await ConvertArrayToString(stageSelectedData);
    let RoleIdToSend;
        let EmpId;
        if (RoleId.includes("3")) {
          RoleIdToSend =3;
         EmpId=EmployeeId;
        } 
        else if (RoleIdArray.includes("7")) {
          RoleIdToSend =7;
         EmpId=EmployeeId;
          }
        else if (RoleIdArray.includes("2")) {
          RoleIdToSend =2;
         EmpId=EmployeeId;
          };

    let obj = {
      CustId: customers,
      FunctionalOwner: functionalOwner,
      StageId: stag,
      RoleId:RoleIdToSend,
      Id:EmpId,
      SortColumn: sortColumn,
      SortOrder: sortOrder,
      SearchText: searchText,
      PageSize: pageSize,
      Start: start,
      Count: count,
    };

    if (api === "submit") {
      let check = Validation();
      if (check) {
        setPostObject(obj);
        await GetGridData(obj);
      } else {
        setStageSelectedData([]);
        setCustomersSelected([]);
        setFunctionalOwnerSelected([]);
      }
    }

    if (api === "reset") {
      setStageSelectedData([]);
      setCustomersSelected([]);
      setFunctionalOwnerSelected([]);
      setReset(!reset);
    }
  };

  const ExportToExcel = () => {
    let customers = ConvertArrayToString(customersSelected);
    let functionalOwner = ConvertArrayToString(functionalOwnerSelected);
    let stag = ConvertArrayToString(stageSelectedData);
    let RoleIdToSend;
    let EmpId;
    if (RoleId.includes("3")) {
      RoleIdToSend =3;
     EmpId=EmployeeId;
    } 
    else if (RoleIdArray.includes("7")) {
      RoleIdToSend =7;
     EmpId=EmployeeId;
      }
    else if (RoleIdArray.includes("2")) {
      RoleIdToSend =2;
     EmpId=EmployeeId;
      };


    let obj = {
      CustId: customers,
      FunctionalOwner: functionalOwner,
      StageId: stag,
      SortColumn: sortColumn,
      SortOrder: sortOrder,
      SearchText: searchText,
      PageSize: count,
      Start: start,
      Count: count,
      RoleId:RoleIdToSend,
      Id:EmpId
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelEngagementReport,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "EngagementReport.xlsx");
      })
      .catch((error) => {});
  };

  const Validation = () => {
    let objError = {};

    formErrorObj = objError;
    setFormErrors(objError);
    const isEmpty = Object.keys(objError).length === 0;

    return isEmpty;
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Engagement Report"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Customers</label>

                    <SelectForm
                      value={customersSelected}
                      onChange={(e: any) => SelectOnChange(e, "customer")}
                      options={customerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Functional Owner</label>

                    <SelectForm
                      value={functionalOwnerSelected}
                      onChange={(e) => SelectOnChange(e, "functionalOwner")}
                      options={functionalOwnerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Stages</label>

                    <SelectForm
                      value={stageSelectedData}
                      onChange={(e) => SelectOnChange(e, "stages")}
                      options={stageoptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                      // disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            {gridData && gridData.length >= 0 && (
              <DynamicGrid
                options={object}
                data={gridData}
                columns={gridColumns}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EngagementReport;
